export default "__VITE_ASSET__Cs0TA_p6__"